import React, { useState } from 'react';
import SelectedTracker from './SelectedTracker';
import TrackerTypeOptions from './TrackerTypeOptions';

interface TrackerTypeSelect {
  selectedType: TrackerType;
  setTrackerType: (value: TrackerType) => void;
  disabled?: boolean;
  errors?: [
    {
      message: string;
    }
  ];
}

const TrackerTypeSelect: React.FC<TrackerTypeSelect> = ({
  selectedType,
  setTrackerType,
  disabled,
  errors = []
}) => {
  const [isSelecting, setIsSelecting] = useState(false);

  function _setTrackerType(value: TrackerType) {
    setTrackerType(value);
    setIsSelecting(false);
  }

  return (
    <div className="relative overflow-visible">
      <SelectedTracker
        type={selectedType}
        disabled={disabled}
        hasError={errors.length > 0}
        data-testid="expand-tracker-selection"
        onClick={() => setIsSelecting(true)}
      />
      {!disabled && isSelecting && (
        <div className="w-100 absolute top-0 bottom-0 z-5">
          <TrackerTypeOptions selectedType={selectedType} setTrackerType={_setTrackerType} />
        </div>
      )}
    </div>
  );
};

export default TrackerTypeSelect;
